const DOT_COLS = 8;
const DOT_ROWS = 4;
const DOT_SPACING = 28;
const DOT_MARGIN = 14;
const DOT_RADIUS = 3;

const dots = [];
for (let row = 0; row < DOT_ROWS; row++) {
  for (let col = 0; col < DOT_COLS; col++) {
    dots.push(
      <circle
        key={`${row}-${col}`}
        cx={DOT_MARGIN + col * DOT_SPACING}
        cy={DOT_MARGIN + row * DOT_SPACING}
        r={DOT_RADIUS}
      />
    );
  }
}

const viewWidth = DOT_MARGIN * 2 + (DOT_COLS - 1) * DOT_SPACING;
const viewHeight = DOT_MARGIN * 2 + (DOT_ROWS - 1) * DOT_SPACING;

const DotGridIcon = (
  <svg
    width="260"
    height="130"
    viewBox={`0 0 ${viewWidth} ${viewHeight}`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs>
      <radialGradient id="dotFade" cx="50%" cy="50%" r="75%">
        <stop offset="0%" stopColor="#FFFFFF" stopOpacity="1" />
        <stop offset="60%" stopColor="#FFFFFF" stopOpacity="0.8" />
        <stop offset="100%" stopColor="#FFFFFF" stopOpacity="0" />
      </radialGradient>
      <mask id="dotMask">
        <rect x="0" y="0" width={viewWidth} height={viewHeight} fill="url(#dotFade)" />
      </mask>
    </defs>

    <g mask="url(#dotMask)" fill="#80CAEE" fillOpacity="0.8">
      {dots}
    </g>
  </svg>
);

export default DotGridIcon;
